import { isSameDay } from 'date-fns';
import { HeaderProps } from 'react-big-calendar';

export const WeekHeader: React.ComponentType<HeaderProps> = ({
  label,
  date,
}) => {
  const [[numbers], [letters]] = separateString(label);
  return (
    <div className="pb-1 text-sm leading-6 text-gray-500 hover:text-gray-900 transition">
      {letters}
      <span
        className={`mt-1 font-semibold  ${
          isSameDay(new Date(), date)
            ? ' ml-2 bg-primary-600 hover:bg-primary-500 font-semibold  text-white'
            : 'text-gray-900'
        }  h-6 w-6 inline-block rounded-full print:bg-inherit print:text-gray-900`}
      >
        {numbers}
      </span>
    </div>
  );
};

function separateString(str: string) {
  const numbers = str.match(/\d+/g) || []; // Match all digits in the string
  const letters = str.match(/[a-zA-Z]+/g) || []; // Match all letters in the string
  return [numbers, letters];
}
